import React from 'react';

import SingleMonitoringDevice from 'src/features/monitoring/components/SingleMonitoringDevice';
import { MonitoringHealthComponent } from 'src/features/monitoring/types';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

type MonitoringDevicesSectionProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    devices: MonitoringHealthComponent[];
    isLoading: boolean;
};

export default function MonitoringDevicesSection({
    title,
    subtitle,
    devices,
    isLoading,
}: MonitoringDevicesSectionProps) {
    if (!isLoading && devices.length === 0) return null;

    return (
        <SectionBlock>
            <SectionBlockHeader>
                <SectionBlockHead>
                    <SectionBlockTitle>{title}</SectionBlockTitle>
                    {subtitle && <SectionBlockSubtitle>{subtitle}</SectionBlockSubtitle>}
                </SectionBlockHead>
            </SectionBlockHeader>
            <SectionBlockSeparator />
            <SectionBlockBody className="grid md:grid-cols-2 xl:grid-cols-3">
                {isLoading && Array.from({ length: 6 }).map((_, index) => <Skeleton key={index} className="h-32" />)}
                {devices.map((device) => (
                    <SingleMonitoringDevice key={device.id} device={device} />
                ))}
            </SectionBlockBody>
        </SectionBlock>
    );
}
